import { DateObject } from "react-multi-date-picker";

export const dateToString = (date: DateObject): string => {
  const d = date.toDate();
  return `${d.toLocaleDateString("ru-ru", {
    month: "numeric",
    day: "numeric",
  })} ${d.toLocaleDateString("ru-ru", { weekday: "short" })}`;
};
